import React, { Component } from 'react';

import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import Button from '../../artzu-ui/src/Button';

class DesktopFooter extends Component {
  render() {
    return (
      <div className="report__footer--container">
        <Button onClick={this.props.onClick} className="signup__footer--button" primary label="Send" type="submit" />
      </div>
    );
  }
}

export default withRouter(withApollo(DesktopFooter));



// WEBPACK FOOTER //
// ./src/components/Report/DesktopFooter.js